// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file common/v1/workers.proto (package workernet.workers, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/workers.proto.
 */
export const file_common_v1_workers: GenFile = /*@__PURE__*/
  fileDesc("Chdjb21tb24vdjEvd29ya2Vycy5wcm90bxIRd29ya2VybmV0LndvcmtlcnMi/AMKA09JRBILCgNvaWQYASABKAkSEwoLb2JqZWN0X25hbWUYAiABKAkSEQoJdGFibGVfb2lkGAMgASgJEhcKD21heF9yZXBldGl0aW9ucxgEIAEoAxIPCgd0aW1lb3V0GAUgASgDEg8KB3JldHJpZXMYBiABKAMSEAoIaXNfdGFibGUYByABKAgSEwoLb2ZmbG9hZF9zZWMYCCABKAMSFwoKbXVsdGlwbGllchgJIAEoAUgAiAEBEhcKCmZpZWxkX3R5cGUYCiABKAlIAYgBARIaCg12YWx1ZV9tYXBwaW5nGAsgASgJSAKIAQESHgoRcmF3X3ZhbHVlX21hcHBpbmcYDCABKAlIA4gBARIVCghyb3VuZF90bxgNIAEoA0gEiAEBEhkKDGluZGV4X29mZnNldBgOIAEoA0gFiAEBEhsKDnR3b3NfY29tcF9iaXRzGA8gASgDSAaIAQESGQoMdXNlX2dldF9uZXh0GBAgASgISAeIAQFCDQoLX211bHRpcGxpZXJCDQoLX2ZpZWxkX3R5cGVCEAoOX3ZhbHVlX21hcHBpbmdCFAoSX3Jhd192YWx1ZV9tYXBwaW5nQgsKCV9yb3VuZF90b0IPCg1faW5kZXhfb2Zmc2V0QhEKD190d29zX2NvbXBfYml0c0IPCg1fdXNlX2dldF9uZXh0IhgKCU9udVNlcmlhbBILCgNoZXgYASABKAkqXAoRU25tcFNlY3VyaXR5TGV2ZWwSFgoSTk9fQVVUSF9PUl9QUklWQUNZEAASGAoUQVVUSF9XSVRIT1VUX1BSSVZBQ1kQARIVChFBVVRIX1dJVEhfUFJJVkFDWRACKiAKDEF1dGhQcm90b2NvbBIHCgNNRDUQABIHCgNTSEEQASogCgxQcml2UHJvdG9jb2wSBwoDREVTEAASBwoDQUVTEAEqIwoOUmVzcG9uc2VTdGF0dXMSBgoCT0sQABIJCgVFUlJPUhABKiQKDVNlcnZpY2VTdGF0dXMSCQoFU1RBUlQQABIICgRTVE9QEAEqKgoHUG9uVHlwZRIICgRFUE9OEAASCAoER1BPThABEgsKB1VOS05PV04QAio5Cg9EZXJlZ1JlYXNvblR5cGUSBwoDTE9TEAASCAoETE9TSRABEggKBExPRkkQAhIJCgVPVEhFUhADKhwKCElmU3RhdHVzEgYKAlVQEAASCAoERE9XThABQjpaOGdpdGh1Yi5jb20vd29ya2VybmV0L2JhY2tlbmQvcGtnL3BiL3dvcmtlcnMvdjE7d29ya2Vyc3YxYgZwcm90bzM");

/**
 * @generated from message workernet.workers.OID
 */
export type OID = Message<"workernet.workers.OID"> & {
  /**
   * @generated from field: string oid = 1;
   */
  oid: string;

  /**
   * @generated from field: string object_name = 2;
   */
  objectName: string;

  /**
   * @generated from field: string table_oid = 3;
   */
  tableOid: string;

  /**
   * @generated from field: int64 max_repetitions = 4;
   */
  maxRepetitions: bigint;

  /**
   * @generated from field: int64 timeout = 5;
   */
  timeout: bigint;

  /**
   * @generated from field: int64 retries = 6;
   */
  retries: bigint;

  /**
   * @generated from field: bool is_table = 7;
   */
  isTable: boolean;

  /**
   * @generated from field: int64 offload_sec = 8;
   */
  offloadSec: bigint;

  /**
   * @generated from field: optional double multiplier = 9;
   */
  multiplier?: number | undefined;

  /**
   * @generated from field: optional string field_type = 10;
   */
  fieldType?: string | undefined;

  /**
   * @generated from field: optional string value_mapping = 11;
   */
  valueMapping?: string | undefined;

  /**
   * @generated from field: optional string raw_value_mapping = 12;
   */
  rawValueMapping?: string | undefined;

  /**
   * @generated from field: optional int64 round_to = 13;
   */
  roundTo?: bigint | undefined;

  /**
   * @generated from field: optional int64 index_offset = 14;
   */
  indexOffset?: bigint | undefined;

  /**
   * @generated from field: optional int64 twos_comp_bits = 15;
   */
  twosCompBits?: bigint | undefined;

  /**
   * @generated from field: optional bool use_get_next = 16;
   */
  useGetNext?: boolean | undefined;
};

/**
 * Describes the message workernet.workers.OID.
 * Use `create(OIDSchema)` to create a new message.
 */
export const OIDSchema: GenMessage<OID> = /*@__PURE__*/
  messageDesc(file_common_v1_workers, 0);

/**
 * @generated from message workernet.workers.OnuSerial
 */
export type OnuSerial = Message<"workernet.workers.OnuSerial"> & {
  /**
   * @generated from field: string hex = 1;
   */
  hex: string;
};

/**
 * Describes the message workernet.workers.OnuSerial.
 * Use `create(OnuSerialSchema)` to create a new message.
 */
export const OnuSerialSchema: GenMessage<OnuSerial> = /*@__PURE__*/
  messageDesc(file_common_v1_workers, 1);

/**
 * @generated from enum workernet.workers.SnmpSecurityLevel
 */
export enum SnmpSecurityLevel {
  /**
   * @generated from enum value: NO_AUTH_OR_PRIVACY = 0;
   */
  NO_AUTH_OR_PRIVACY = 0,

  /**
   * @generated from enum value: AUTH_WITHOUT_PRIVACY = 1;
   */
  AUTH_WITHOUT_PRIVACY = 1,

  /**
   * @generated from enum value: AUTH_WITH_PRIVACY = 2;
   */
  AUTH_WITH_PRIVACY = 2,
}

/**
 * Describes the enum workernet.workers.SnmpSecurityLevel.
 */
export const SnmpSecurityLevelSchema: GenEnum<SnmpSecurityLevel> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 0);

/**
 * @generated from enum workernet.workers.AuthProtocol
 */
export enum AuthProtocol {
  /**
   * @generated from enum value: MD5 = 0;
   */
  MD5 = 0,

  /**
   * @generated from enum value: SHA = 1;
   */
  SHA = 1,
}

/**
 * Describes the enum workernet.workers.AuthProtocol.
 */
export const AuthProtocolSchema: GenEnum<AuthProtocol> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 1);

/**
 * @generated from enum workernet.workers.PrivProtocol
 */
export enum PrivProtocol {
  /**
   * @generated from enum value: DES = 0;
   */
  DES = 0,

  /**
   * @generated from enum value: AES = 1;
   */
  AES = 1,
}

/**
 * Describes the enum workernet.workers.PrivProtocol.
 */
export const PrivProtocolSchema: GenEnum<PrivProtocol> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 2);

/**
 * @generated from enum workernet.workers.ResponseStatus
 */
export enum ResponseStatus {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: ERROR = 1;
   */
  ERROR = 1,
}

/**
 * Describes the enum workernet.workers.ResponseStatus.
 */
export const ResponseStatusSchema: GenEnum<ResponseStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 3);

/**
 * @generated from enum workernet.workers.ServiceStatus
 */
export enum ServiceStatus {
  /**
   * @generated from enum value: START = 0;
   */
  START = 0,

  /**
   * @generated from enum value: STOP = 1;
   */
  STOP = 1,
}

/**
 * Describes the enum workernet.workers.ServiceStatus.
 */
export const ServiceStatusSchema: GenEnum<ServiceStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 4);

/**
 * @generated from enum workernet.workers.PonType
 */
export enum PonType {
  /**
   * @generated from enum value: EPON = 0;
   */
  EPON = 0,

  /**
   * @generated from enum value: GPON = 1;
   */
  GPON = 1,

  /**
   * @generated from enum value: UNKNOWN = 2;
   */
  UNKNOWN = 2,
}

/**
 * Describes the enum workernet.workers.PonType.
 */
export const PonTypeSchema: GenEnum<PonType> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 5);

/**
 * @generated from enum workernet.workers.DeregReasonType
 */
export enum DeregReasonType {
  /**
   * @generated from enum value: LOS = 0;
   */
  LOS = 0,

  /**
   * @generated from enum value: LOSI = 1;
   */
  LOSI = 1,

  /**
   * @generated from enum value: LOFI = 2;
   */
  LOFI = 2,

  /**
   * @generated from enum value: OTHER = 3;
   */
  OTHER = 3,
}

/**
 * Describes the enum workernet.workers.DeregReasonType.
 */
export const DeregReasonTypeSchema: GenEnum<DeregReasonType> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 6);

/**
 * @generated from enum workernet.workers.IfStatus
 */
export enum IfStatus {
  /**
   * @generated from enum value: UP = 0;
   */
  UP = 0,

  /**
   * @generated from enum value: DOWN = 1;
   */
  DOWN = 1,
}

/**
 * Describes the enum workernet.workers.IfStatus.
 */
export const IfStatusSchema: GenEnum<IfStatus> = /*@__PURE__*/
  enumDesc(file_common_v1_workers, 7);

